import { Component, OnInit } from '@angular/core';
import { ConsultaService } from '../../services/consulta.service';
import { AdministraMarcasService } from '../../services/administra-marcas.service';
import { Router } from '@angular/router';
import { ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { URL_IMG } from '../../../conf/url.servicios';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-administra-marcas',
  templateUrl: './administra-marcas.component.html',
  styleUrls: ['./administra-marcas.component.css']
})
export class AdministraMarcasComponent implements OnInit {

  rutaImagen = URL_IMG;
  title = "Administración de Marcas";
  marcas: any = [];

  constructor(private router: Router, private fb: FormBuilder, private consultaService: ConsultaService,
  private marcasService: AdministraMarcasService, private activatedRoute:ActivatedRoute) { }

  ngOnInit() {
    if (!this.consultaService.esNuevaSession()) {
      this.activatedRoute.params.subscribe(params=>{
          this.obtieneCategorias(params['idMarca']);
        })
    }
  }


    obtieneCategorias(idMarca:any) {
      this.marcasService.obtieneMarcas().then(resolve => {
        this.marcas = this.marcasService.marcas;
      });
    }

    editaCategorias(item:any){
        this.router.navigate(['/administraCategorias',item.N_ID]);
    }

}



// WEBPACK FOOTER //
// C:/Users/EZepeda/Desktop/Explora/adminexplora/src/app/components/administra-marcas/administra-marcas.component.ts